module.exports = __webpack_public_path__ + "static/media/home-background-nb.6fae30b9.webp";